//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useContext, useState } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';

// === COMPONENTS ===
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';

// === API ===

// === UTILS ===

//#endregion

//-----------------------------------------------------------------
export function DataTypeSelect( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, type, onChange } = props;

  const _datatype_items = [
    { label: 'Amount'         , value: 'amount'  },
    { label: 'Date'           , value: 'date'    },
    { label: 'String'         , value: 'string'  },
    { label: 'String (Fuzzy)' , value: 'fuzzy'   },
    { label: 'Street Address' , value: 'address' },
  ]

  const { updateExpression, updatePredicate } = useContext( ExpressionContext );

  const [ type_value, setTypeValue ] = useState( type || 'string' );
  const [ type_label, setTypeLabel ] = useState( type || 'String' );

  //#endregion

  //#region [STYLES]

  const theme = useTheme();
  const _styles = {
    select_datatype: {
      width: '140px',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
  }

  const SELECT_DATATYPE = {
    sx       : _styles.select_datatype,
    labelId  : 'datatype-label',
    id       : 'datatype-select',
    options  : _datatype_items,
    value    : type_value,
    size     : 'small',
    onChange : onChange_Type,
    children : _datatype_items.map( item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>),
    name     : 'da_predicate_type_select',
  };
    
  //#endregion

  //#region [EVENTS]
  
  //-----------------------------------------------------------------
  function onChange_Type( event ) {
    //-----------------------------------------------------------------
    setTypeValue( event.target.value );
    if( onChange ) onChange( event.target.value );
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <FormControl sx={{ minWidth: '148px' }}>
        <InputLabel id="datatype-label">Type</InputLabel>
        <Select   { ...SELECT_DATATYPE } />
      </FormControl>
    );
  }

  //#endregion

  return display();
}
